// extracted by mini-css-extract-plugin
export default {"popupClose":"LogoutPopup_popupClose__Ryvgz"};